import { FileRejection } from 'react-dropzone';
import { AppDispatch } from '../app/store';
import loadingSlice from '../pages/Loading/loadingSlice';

export default function handleDropRejected(
  fileRejections: FileRejection[],
  dispatch: AppDispatch,
  maxSizeInMB?: number
) {
  const errorCodes = fileRejections.flatMap(({ errors }) =>
    errors.map(({ code }) => code)
  );

  const count = fileRejections.length;
  let message = `Your ${count} file${count > 1 ? 's' : ''} cannot be uploaded`;

  if (maxSizeInMB && errorCodes.some((code) => code === 'file-too-large')) {
    const largeFileCount = errorCodes.filter(
      (code) => code === 'file-too-large'
    ).length;
    message = `Your ${largeFileCount} uploaded file${
      largeFileCount > 1 ? 's are' : ' is'
    } larger than ${maxSizeInMB} MB`;
  }

  dispatch(loadingSlice.actions.error({ message }));
}
